import { FC } from 'react'

import styled from 'styled-components'

import SuccessIcon from 'src/Assets/Svg/pages-icons/Success.svg?react'
import { GreyTextButton } from 'src/Components/Buttons/GreyTextButton'
import { FullScreenModal } from 'src/Components/FullScreenModal'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
`

const Container = styled.div`
  display: flex;
  max-width: 358px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    max-width: 600px;
  }
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

const Text = styled(Title)`
  font-size: 14px;
  font-weight: 400;
`

const StyledSuccessIcon = styled(SuccessIcon)`
  color: ${({ theme }) => theme.color.brandGreen};
`

const StyledGreyTextButton = styled(GreyTextButton)`
  padding-left: 40px;
  padding-right: 40px;
`

const ICON_SIZE = 40

export interface SuccessCreatedPreReleaseCampaignProps {
  onContinue: () => void
}

export const SuccessCreatedPreReleaseCampaign: FC<
  SuccessCreatedPreReleaseCampaignProps
> = ({ onContinue }) => (
  <FullScreenModal open>
    <Wrapper>
      <Container>
        <StyledSuccessIcon width={ICON_SIZE} height={ICON_SIZE} />
        <div>
          <Title>
            <span>Your campaign has been created! 🎉</span>
          </Title>
          <Text>
            Complete your setup and upload your track to start pitching to
            Spotify curators.
          </Text>
        </div>

        <StyledGreyTextButton onClick={onContinue}>
          Continue
        </StyledGreyTextButton>
      </Container>
    </Wrapper>
  </FullScreenModal>
)
